import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { TrendingUp } from "lucide-react";
import { useLang } from "@/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResultsCounter() {
  const { t } = useLang();
  const [data, setData] = useState(null);
  const [shown, setShown] = useState(0);
  const [start, setStart] = useState(false);

  useEffect(() => {
    fetch(`${API}/stats`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => setData(d))
      .catch(() => {});
  }, []);

  const target = data?.segnalazioni_cancellate || 0;

  useEffect(() => {
    if (!start || !target) return;
    const dur = 1400;
    const t0 = performance.now();
    let raf;
    const step = (now) => {
      const p = Math.min(1, (now - t0) / dur);
      setShown(Math.round(target * (1 - Math.pow(1 - p, 3))));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [start, target]);

  if (!target) return null;

  const updated = data?.updated_at
    ? new Date(data.updated_at).toLocaleDateString("it-IT", { month: "long", year: "numeric" })
    : null;

  return (
    <section className="px-4 sm:px-6 py-6" data-testid="results-counter">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        onViewportEnter={() => setStart(true)}
        transition={{ duration: 0.6 }}
        className="max-w-4xl mx-auto rounded-3xl bg-gradient-to-br from-[#002260] to-[#003087] border border-[#00AEEF]/30 px-6 py-10 sm:py-12 text-center relative overflow-hidden"
      >
        <div className="absolute -top-20 -right-20 w-64 h-64 rounded-full bg-[#00AEEF]/10 blur-3xl" />
        <div className="inline-flex items-center gap-2 text-[#00AEEF] text-xs font-bold tracking-[0.2em] uppercase mb-4">
          <TrendingUp size={14} /> {t("counter.updated")}{updated ? ` ${updated}` : ""}
        </div>
        <div data-testid="results-counter-value" className="text-6xl sm:text-7xl font-extrabold text-white leading-none">
          {shown.toLocaleString("it-IT")}
        </div>
        <p className="text-[#00AEEF] font-bold text-lg sm:text-xl mt-3">{t("counter.title")}</p>
        <p className="text-[#9BDDF7] text-sm mt-1">{t("counter.sub")}</p>
      </motion.div>
    </section>
  );
}
